import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function AuthGuard({ allowedRoles }) {
  const { token, user } = useSelector(state => state.auth )

  // Not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Role-based restriction
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
